import React, { useEffect, useState } from "react";
import ClientNavbar from "../ClientLayout/ClientNavbar";
import ClientSidebar from "../ClientLayout/ClientSidebar";
import ClientFooter from "../ClientLayout/ClientFooter";
import { Container, Card, Table } from "react-bootstrap";
import zoomicon from "../../../assets/img/zoomicon.png";
import googlemeeticon from "../../../assets/img/googlemeeticon.png";
import { API_URL } from "../../../Constant";


const ClientDashboard = () => {
  const [appointments, setAppointments] = useState([]);
  const [pastAppointments, setPastAppointments] = useState([]);
  const [currentTime, setCurrentTime] = useState("");
  const loginId = localStorage.getItem("loginId");
  
  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const response = await fetch(
          `${API_URL}api/Counsellor/GetAptDetailsForClient/${loginId}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch appointments");
        }

        const data = await response.json();

        const today = new Date().toLocaleString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" }).split("/").join("-");

        const filteredUpcomingAppointments = data.filter((appointment) => {
          const appointmentDate = new Date(appointment.appointmentDate).toLocaleString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" }).split("/").join("-");
          return appointmentDate >= today;
        });
        setAppointments(filteredUpcomingAppointments);

        const filteredPastAppointments = data.filter((appointment) => {
          const appointmentDate = new Date(appointment.appointmentDate).toLocaleString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" }).split("/").join("-");
          return appointmentDate < today;
        });
        setPastAppointments(filteredPastAppointments);



      } catch (error) {
        console.error("Error fetching appointments:", error);
      }
    };

    fetchAppointments();
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const formattedTime = now.toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata", // IST timezone
        weekday: "short", // e.g., Tue
        year: "numeric",
        month: "short", // e.g., Mar
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true, // 12-hour format
      });

      setCurrentTime(formattedTime);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <ClientNavbar />
      <div className="d-flex">
        <ClientSidebar />
        <Container fluid className="p-4">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <h2 className="cheading">Dashboard</h2>

            <span
              style={{
                fontSize: "1rem",
                fontWeight: "500",
                color: "#333",
              }}
            >
              📅 {currentTime}
            </span>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Card className="shadow-sm" style={{ padding: "0px" }}>
                <Card.Body
                  className="alert alert-primary alert-dismissible fade show"
                  style={{
                    marginBottom: "0px",
                    borderBottom: "3px solid darkblue",
                  }}
                >
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left", paddingBottom: "7px" }}
                    >
                      Appointments
                    </Card.Title>
                  </center>
                  <div style={{ overflowX: "auto" }} className="row p-0 m-0">
                    <div className="col-md-8 p-0 m-0"></div>
                    <div
                      className="col-md-4 p-0 m-0"
                      style={{ textAlign: "right" }}
                    >
                      <p
                        className="mb-0"
                        style={{ fontSize: "1.5rem", fontWeight: "600" }}
                      >
                        46
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>



            <div className="col-md-4">
              <Card className="shadow-sm" style={{ padding: "0px" }}>
                <Card.Body
                  className="alert alert-danger alert-dismissible fade show"
                  style={{
                    marginBottom: "0px",
                    borderBottom: "3px solid red",
                  }}
                >
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left", paddingBottom: "7px" }}
                    >
                      Cancelled Appointments
                    </Card.Title>
                  </center>
                  <div style={{ overflowX: "auto" }} className="row p-0 m-0">
                    <div className="col-md-8 p-0 m-0"></div>
                    <div
                      className="col-md-4 p-0 m-0"
                      style={{ textAlign: "right" }}
                    >
                      <p
                        className="mb-0"
                        style={{ fontSize: "1.5rem", fontWeight: "600" }}
                      >
                        12
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>

          </div>

          <div className="row mt-4">
            <div className="col-md-12">
              <div
                className="alert alert-success alert-dismissible fade show"
                role="alert"
                style={{ marginBottom: "0px", borderLeft: "5px solid green" }}
              >
                Invoice No. #354 is under review
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Card className="shadow-sm" style={{ padding: "0px" }}>
                <Card.Body>
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left" }}
                    >
                      <i
                        className="fas fa-calendar-alt"
                        style={{ marginRight: "5px", color: "#007bff" }}
                      ></i>
                      📅 &nbsp;Upcomming Appointments
                    </Card.Title>{" "}
                  </center>
                  <Table bordered hover className="responsive">
                    <thead className="ctableheading">
                      <tr>
                        <th>Sr. No.</th>
                        <th>Counsellor Name</th>
                        <th>Date</th>
                        <th>Time</th>
                        {/* <th>Duration (mins)</th> */}
                        <th>Meeting Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      {appointments.length > 0 ? (
                        appointments.map((appointment, index) => (
                          <tr key={appointment.appointmentId}>
                            <td>{index + 1}</td>
                            <td>
                              {appointment.counselorFirstName}{" "}
                              {appointment.counselorLastName}
                            </td>
                            <td>
                              {/* {new Date(
                                appointment.appointmentTime
                              ).toLocaleDateString()} */}
                              {appointment.appointmentDate}
                            </td>
                            <td>
                              {/* {new Date(
                                appointment.appointmentTime
                              ).toLocaleTimeString()} */}
                              {appointment.appointmentTime}
                            </td>
                            {/* <td>{appointment.duration}</td> */}
                            <td>

                              <img
                                src={googlemeeticon}
                                alt="Google Meet"
                                style={{ width: "30px", marginRight: "4px" }}
                              />
                              <a
                                href={appointment.zoomMeetingLink}
                                target="_blank"
                                className="btn btn-primary"
                                rel="noopener noreferrer"
                                style={{ padding: "1px 6px" }}
                              >
                                Join
                              </a>
                              <button
                                type="button"
                                className="btn"
                                style={{
                                  padding: "1px 5px",
                                  marginLeft: "10px",
                                  backgroundColor: "#5CB85C",
                                  color: "white",
                                }}
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    appointment.zoomMeetingLink
                                  );
                                }}
                              >
                                Copy
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No Appointments Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </div>
            <div className="col-md-6">
              <Card className="shadow-sm" style={{ padding: "0px" }}>
                <Card.Body>
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left" }}
                    >
                      <i
                        className="fas fa-calendar-alt"
                        style={{ marginRight: "5px", color: "#007bff" }}
                      ></i>
                      📅 &nbsp;Past Appointments
                    </Card.Title>{" "}
                  </center>
                  <Table bordered hover className="responsive">
                    <thead className="ctableheading">
                      <tr>
                        <th>Sr. No.</th>
                        <th>Counsellor Name</th>
                        <th>Date</th>
                        <th>Time</th>
                        {/* <th>Duration (mins)</th> */}
                        <th>Meeting Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pastAppointments.length > 0 ? (
                        pastAppointments.map((appointment, index) => (
                          <tr key={appointment.appointmentId}>
                            <td>{index + 1}</td>
                            <td>
                              {appointment.counselorFirstName}{" "}
                              {appointment.counselorLastName}
                            </td>
                            <td>
                              {appointment.appointmentDate}
                            </td>
                            <td>
                              {appointment.appointmentTime}
                            </td>
                            {/* <td>{appointment.duration}</td> */}
                            <td>
                              <img
                                src={zoomicon}
                                alt="Zoom"
                                style={{ width: "22px", marginRight: "5px" }}
                              />
                              &nbsp;
                              <a
                                href={appointment.zoomMeetingLink}
                                target="_blank"
                                className="btn btn-warning"
                                rel="noopener noreferrer"
                                style={{ padding: "1px 6px" }}
                              >
                                Cancelled
                              </a>

                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No Appointments Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </div>
          </div>
        </Container>
      </div>
      <ClientFooter />
    </>
  );
};

export default ClientDashboard;
